import { backofficeRequest } from '../../../axios'

export const getTickets = async (search = null) => {
  try {
    const { data } = await backofficeRequest.get('backoffice/front/tickets', {
      params: {
        query: search,
      },
    })
    return data
  } catch (error) {
    return error
  }
}

export const getAssociatedTickets = async (conversationId) => {
  try {
    const { data: tickets } = await backofficeRequest.get(
      `backoffice/front/conversations/${conversationId}/tickets`
    )
    return tickets
  } catch (error) {
    return error
  }
}

export const linkInternalTicketsToFrontConversation = async (
  conversationId,
  data
) => {
  const { tickets, frontTicket } = data

  const ticketIds = tickets.map((ticket) => ticket.id)

  try {
    if (ticketIds.length > 0) {
      await backofficeRequest.post(
        `backoffice/front/conversations/${conversationId}/tickets`,
        {
          ticketIds,
          frontTicket,
        }
      )
    }
  } catch (error) {
    return error
  }
}

export const unlinkInternalTicketFromFrontConversation = async ({
  internalTicketId,
  conversationId,
}) => {
  try {
    await backofficeRequest.delete(
      `backoffice/front/conversations/${conversationId}/tickets/${internalTicketId}`
    )
  } catch (error) {
    return error
  }
}
